import { Deserializable } from '../deserializable';
import { Agent } from './agent.model';

export class AgentCaseAdministrator implements Deserializable {
  public Id: string;
  public BusinessWriterId: string;
  public AgentID: number;
  public CaseAdministratorID: number;
  public RightCode: string;
  public ReceiveCaseNotifications?: boolean;
  public Agent: Agent;
  public CaseAdministrator: Agent;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
